import {config} from '@/Config';
class HotelApi {
  // General Tab Initial Data
  public GetGeneral() {
    return `${config.apiBaseUrl}business/hotel/general-tab/retrieve`;
  }
  //update
  public PutGeneral(hotelId: number) {
    return `${config.apiBaseUrl}business/hotel/edit-general-tab`;
  }

  //get notice
  public GetNotice() {
    return `${config.apiBaseUrl}business/hotel/notice-tab/retrieve`;
  }
  public UpdateNotice(hotelId: number) {
    return `${config.apiBaseUrl}business/hotel/edit-notice-tab`;
  }

  //hotelnotice
  public GetTime() {
    return `${config.apiBaseUrl}business/hotel/time-tab/retrieve`;
  }
  public UpdateTime(hotelId: number) {
    return `${config.apiBaseUrl}business/hotel/edit-time-tab`;
  }

  //city
  public cityList() {
    return `${config.apiBaseUrl}common/hotel/city/list`;
  }
  public cityUpdate() {
    return `${config.apiBaseUrl}common/hotel/add/city`;
  }

  //location
  public GetLocation() {
    return `${config.apiBaseUrl}business/hotel/location-tab/retrieve`;
  }
  public UpdateLocation(hotelId: number) {
    return `${config.apiBaseUrl}business/hotel/edit-location-tab`;
  }

  /************************Hotel Amenity start.*************************************/

  //hotel service list
  public getAmenityList() {
    return `${config.apiBaseUrl}business/amenity/list`;
  }

  //hotel service add title
  public addAmenityTitle() {
    return `${config.apiBaseUrl}business/amenity/add`;
  }

  // add tag for service
  public addAmenityImage() {
    return `${config.apiBaseUrl}business/amenity/icon/upload`;
  }

  // edit Service
  public editAmenity() {
    return `${config.apiBaseUrl}business/amenity/edit`;
  }

  // retrive service
  public getAmenity() {
    return `${config.apiBaseUrl}business/amenity/retrieve`;
  }
  /************************Hotel amenity end.*************************************/
  //faq
  // List
  public FaqList(hotelId: number) {
    return `${config.apiBaseUrl}business/hotel/faq/list`;
  }

  // add Includes
  public AddFaq() {
    return `${config.apiBaseUrl}business/hotel/faq/add`;
  }

  public EditFaq() {
    return `${config.apiBaseUrl}business/hotel/faq/edit`;
  }

  // delete Includes
  public DeleteSelectedFaq() {
    return `${config.apiBaseUrl}business/hotel/faq/delete`;
  }

  public amenityList() {
    return `${config.apiBaseUrl}common/hotel/amenity/list`;
  }

  //hotel amenity
  // List
  public allHotelAmenity(hotelId: number) {
    return `${config.apiBaseUrl}business/hotel/amenity/all/list`;
  }

  // add hotel amenity
  public addHotelAmenity() {
    return `${config.apiBaseUrl}business/hotel/amenity/add`;
  }

  public editHotelAmenity() {
    return `${config.apiBaseUrl}business/hotel/amenity/edit`;
  }

  //delete amenity
  public deleteHotelAmenity() {
    return `${config.apiBaseUrl}business/hotel/amenity/delete`;
  }

  public removeHotelAmenityservice() {
    return `${config.apiBaseUrl}business/hotel/amenity/service/remove`;
  }

  // Image Gallery List
  public ImageList() {
    return `${config.apiBaseUrl}business/hotel/image/list`;
  }

  public MakeBannerImage() {
    return `${config.apiBaseUrl}business/hotel/image/make-banner`;
  }

  public AddGalleryImage() {
    return `${config.apiBaseUrl}business/hotel/image/add`;
  }

  public DeleteImage() {
    return `${config.apiBaseUrl}business/hotel/image/delete`;
  }
  /************************Hotel Room Start.*************************************/
  public getRoomList() {
    return `${config.apiBaseUrl}business/hotel/room/list`;
  }

  public addRoomInfo() {
    return `${config.apiBaseUrl}business/hotel/room/add`;
  }

  public geRoomInfo() {
    return `${config.apiBaseUrl}business/hotel/room/retrieve`;
  }

  public updateRoomInfo(hotelId: number) {
    return `${config.apiBaseUrl}business/hotel/room/edit`;
  }

  //room gallery
  public roomImageList() {
    return `${config.apiBaseUrl}business/hotel/room/image/list`;
  }

  public maekRoomBannerImage() {
    return `${config.apiBaseUrl}business/hotel/room/image/make-banner`;
  }

  public addRoomImage() {
    return `${config.apiBaseUrl}business/hotel/room/image/add`;
  }

  public deleteRoomImage() {
    return `${config.apiBaseUrl}business/hotel/room/image/delete`;
  }

  public serviceList() {
    return `${config.apiBaseUrl}hotel/service/list`;
  }

  //room package
  public roomPackageList() {
    return `${config.apiBaseUrl}business/hotel/room/package/list`;
  }

  public addRoomPackage() {
    return `${config.apiBaseUrl}business/hotel/room/package/add`;
  }

  //room amenity

  public roomAmenityList() {
    return `${config.apiBaseUrl}business/hotel/room/amenity/all/list`;
  }

  // add hotel amenity
  public addRoomAmenity() {
    return `${config.apiBaseUrl}business/hotel/room/amenity/add`;
  }

  public editRoomAmenity() {
    return `${config.apiBaseUrl}business/hotel/room/amenity/edit`;
  }

  //delete amenity
  public deleteRoomAmenity() {
    return `${config.apiBaseUrl}business/hotel/room/amenity/delete`;
  }

  public removeRoomAmenityservice() {
    return `${config.apiBaseUrl}business/hotel/room/amenity/service/remove`;
  }

  //set payment method
  public setPaymentMethod() {
    return `${config.apiBaseUrl}business/hotel/payment/method/add`;
  }

  public hotelPaymentList(hotelId: number) {
    return `${config.apiBaseUrl}business/hotel/payment/method/list`;
  }

  public paymentChecked(hotelId: number) {
    return `${config.apiBaseUrl}business/hotel/payment/method/checked`;
  }

  //reservation
  public getReservation() {
    return `${config.apiBaseUrl}business/hotel/reservation-tab/retrieve`;
  }
  public upateReservation(hotelId: number) {
    return `${config.apiBaseUrl}business/hotel/edit-reservation-tab`;
  }
}

export const hotelApi = new HotelApi();
